import {
  CloseCircleOutlined,
  DeleteOutlined,
  LeftOutlined,
  PlusOutlined,
  RightOutlined,
} from "@ant-design/icons";
import BoxContent from "@src/component/Desktop/content";
import { Avatar, Button, Carousel, Image, Modal, Tooltip } from "antd";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { workReportNewEquipmentApi } from "../../api/backend/reportNewEquipment";
import { KEY, lang, MODE_SCREEN } from "../../constants/common.const";
import { MSG_CATCH, showMessage } from "../../constants/utils";
import CustomCarouselGroup from "./customCarousel";
import "./workReport.scss";

const CustomPrevArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{
      ...style,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 25,
      height: 25,
      background: "rgba(0,0,0,0.4)",
      borderRadius: "50%",
      zIndex: 2,
      left: 0,
    }}
    onClick={onClick}
  >
    <LeftOutlined style={{ color: "#fff", fontSize: 15 }} />
  </div>
);

const CustomNextArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{
      ...style,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 25,
      height: 25,
      background: "rgba(0,0,0,0.4)",
      borderRadius: "50%",
      zIndex: 2,
      right: 0,
    }}
    onClick={onClick}
  >
    <RightOutlined style={{ color: "#fff", fontSize: 15 }} />
  </div>
);
const ReportMachineImage = ({
  mode = MODE_SCREEN.ADD,
  setImage,
  listImage = [],
  setListImage,
}) => {
  const { allowRoute, roles } = useSelector((state) => state.auth);
  const [showModalImage, setShowModalImage] = useState(false);
  const isViewMode = mode === MODE_SCREEN.VIEW;
  const avatarElRef = useRef(null);
  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const uploadFile = async (file, type) => {
    const formData = new FormData();
    const body = {
      attachFileName: file.name,
      type: type,
    };
    formData.append("data", JSON.stringify(body));
    formData.append("file", file);

    try {
      const res = await workReportNewEquipmentApi.uploadImage(formData);

      setListImage([
        ...listImage,
        {
          fileName: file.name,
          attachmentUrl: res.data.url,
        },
      ]);

      return res.data;
    } catch (err) {
      showMessage(
        KEY.ERROR,
        (err.response && err.response.data.msg) || MSG_CATCH()
      );
    }
  };
  const handleChangeMachineImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    uploadFile(file, 3);
    avatarElRef.current.value = null;
  };
  const deleteAvatar = () => {
    setImage(null);
  };

  if (mode === MODE_SCREEN.VIEW) {
    return (
      <div>
        {listImage.length == 0 ? (
          <Image preview={false} width={"100%"} src={"/img/default.png"} />
        ) : (
          <Carousel
            prevArrow={<CustomPrevArrow />}
            nextArrow={<CustomNextArrow />}
            arrows
            infinite={false}
          >
            {listImage.map((image, index) => (
              <div>
                <Image
                  onClick={() => {
                    setShowModalImage(true);
                  }}
                  src={image.attachmentUrl}
                  alt={`image-${index}`}
                  style={{
                    width: "100%",
                    height: 300,
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  preview={false}
                />
              </div>
            ))}
          </Carousel>
        )}

        <Modal
          centered
          width={1000}
          visible={showModalImage}
          onCancel={() => setShowModalImage(false)}
          footer={[
            <Button
              className="buttonPC button--outline --todo-- wAuto"
              key="back"
              onClick={() => setShowModalImage(false)}
            >
              <CloseCircleOutlined /> {lang.CLOSE}
            </Button>,
          ]}
        >
          <CustomCarouselGroup
            setShowModalImage={setShowModalImage}
            imgList={listImage.map((image) => image.attachmentUrl)}
          />
        </Modal>
      </div>
    );
  }
  const deleteImage = (index) => {
    setListImage([...listImage.slice(0, index), ...listImage.slice(index + 1)]);
  };

  return (
    <BoxContent style={{ padding: "8px", margin: "8px" }}>
      <input
        type="file"
        className="d-none"
        ref={avatarElRef}
        accept="image/*"
        onChange={handleChangeMachineImage}
      />
      {mode === MODE_SCREEN.ADD && (
        <Button
          onClick={() => {
            avatarElRef.current.click();
          }}
          style={{ width: "100%", height: "150px" }}
          disabled ={listImage.length >=30}
        >
          <b>
            <PlusOutlined /> 写真
          </b>
        </Button>
      )}
      <div className="report-equipment-image-box">
        {listImage.map((image, index) => (
          <div variant="borderless" className="report-equipment-wrap-image">
            <a target="_blank" href={image.attachmentUrl}>
              <div className="report-equipment-image-info">
                <Avatar src={image.attachmentUrl} />

               <Tooltip title={image.fileName}>
               <span>{image.fileName}</span>
               </Tooltip>
              </div>
            </a>
            <DeleteOutlined
              onClick={() => deleteImage(index)}
              style={{
                cursor: "pointer",
                color: "red",
              }}
            />
          </div>
        ))}
      </div>
    </BoxContent>
  );
};

export default ReportMachineImage;
